import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { MealPlan } from '@/api/types'
import { groupBy } from '@/utils'
import { DAYS_OF_WEEK } from '../constants'
import { getNutritionDay } from '../utils'

type Props = {
  mealPlans: MealPlan[]
  mainUserId: number
}

export default function WeekPlanNutrition({ mealPlans, mainUserId }: Props) {
  const { t } = useTranslation()

  const groupedByDays = useMemo(() => groupBy(mealPlans, 'dayOfWeek'), [mealPlans])

  return (
    <div className="WeekPlanRow-Nutrition">
      <h5>{t('mealSimulation.dailyRequirements')}</h5>

      <div className="WeekPlanRow-grid">
        {DAYS_OF_WEEK.map((day) => {
          const nutrition = getNutritionDay(groupedByDays[day], mainUserId)

          return (
            <div key={day} className="WeekPlanNutritionCell">
              <div className="WeekPlanNutritionCell-heading">{nutrition.energy}kcal</div>
              <div className="WeekPlanNutritionCell-row">{nutrition.protein}g</div>
              <div className="WeekPlanNutritionCell-row">{nutrition.carbs}g</div>
              <div className="WeekPlanNutritionCell-row">{nutrition.fat}g</div>
            </div>
          )
        })}
        <div className="WeekPlanNutritionCell">
          <div className="WeekPlanNutritionCell-heading">Energy</div>
          <div className="WeekPlanNutritionCell-row">Protein</div>
          <div className="WeekPlanNutritionCell-row">Carbs</div>
          <div className="WeekPlanNutritionCell-row">Fat</div>
        </div>
      </div>
    </div>
  )
}
